// from: https://github.com/grafana/faro-web-sdk/blob/main/docs/sources/tutorials/quick-start-browser.md#usage-examples
export const LogService = {
    setLoggedInUser(user) {
        // @ts-ignore - faro uses a window global property
        const faro = window.faro;
        if (faro) {
            faro.api.setUser({
                email: user.email,
                id: user.id + "",
                username: user.username,
                attributes: {
                    firstName: user.firstName,
                    lastName: user.lastName
                }
            });
        }
    }
};
